export const dutchLocale = {
  lang: 'nl',
  data: {
    ADMINDOC: {
      NAME: 'Bestandsnaam',
      STATE: 'Status',
      LYANTHE: 'Lyanthe status',
      RELEVANCE: 'Relevatie',
      TYPE: 'Type',
      CREATED_AT: 'Geupload op',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/main/content/ledger/admin-documents/i18n/nl.ts